  <!-- タイトル -->
  <div class="title-area">
    <div class="title-left">
      <h2 mat-subheader class="title">個人設定</h2>
    </div>
  </div>
  @if (showSpinner) {
    <div class="spinner center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
  <!-- カード -->
  <form [formGroup]="form">
    <div class="card">
      <div class="title-left">
        <h3>基本情報</h3>
      </div>

        <div class="form-grid">

          <!-- 左カラム -->
          <div class="form-left">

            <div class="form-row">
              <label class="label-with-required">
                <span class="label-text">名前</span>
                <span class="required">※</span>
              </label>
              <input class="input-text" formControlName="LastName" placeholder="姓" [class.input-invalid]="form.get('LastName')?.invalid && (form.get('LastName')?.touched || form.get('LastName')?.dirty)" (keydown.enter)="$event.preventDefault()"/>
              <input class="input-text" formControlName="firstName" placeholder="名" [class.input-invalid]="form.get('firstName')?.invalid && (form.get('firstName')?.touched || form.get('firstName')?.dirty)" (keydown.enter)="$event.preventDefault()"/>
            </div>

            <div class="form-row manager-row">
              <label class="manager-label">担当</label>

              <div class="manager-content">
                <div class="manager-btn-wrapper">
                  <button mat-raised-button type="button" class="basicinfo manager-btn" (click)="onManger()">選択</button>
                </div>

                <div class="selected-orgs" *ngIf="selectedOrgs?.length">
                  <div *ngFor="let org of selectedOrgs; let i = index" class="org-item">

                    <div class="org-line">
                      <span class="dot">・</span>

                      <span class="org-text">
                        {{ org.path }}

                        <ng-container *ngIf="org.level === 3">
                          <span class="slash"> / </span>

                          <input
                            matInput
                            type="text"
                            maxlength="5"
                            class="org-input"
                            [value]="org.org_count || ''"
                            (input)="onOrgCountInput($event, i)"
                          />

                          <span class="num">人</span>
                        </ng-container>
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>



            <div class="form-row manager-row">
              <label class="manager-label">兼任(専門部)</label>

              <div class="manager-content">
                <div class="manager-btn-wrapper">
                  <button mat-raised-button type="button" class="basicinfo manager-btn" (click)="onConcurrent()">選択</button>
                </div>

                  <div class="selected-orgs" *ngIf="selectedConcurrent?.length">
                    <div *ngFor="let con of selectedConcurrent" class="org-item">
                      ・{{ con.name }}
                    </div>
                  </div>
              </div>
            </div>

            <div class="form-row">
              <label>役職</label>
              <mat-form-field class="officialPosition no-line" appearance="fill">
                <mat-select panelWidth="314px" formControlName="officialPosition" #officialPositionSelect (keydown)="onSelectChange(officialPositionSelect)">
                  <mat-option [value]="null"></mat-option>
                  <mat-option *ngFor="let item of officialPositions" [value]="item.value">
                    {{ item.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
                <!-- 専従 -->
              <div class="checkbox-area">
                <mat-checkbox formControlName="isFullTime" class="thin-checkbox" labelPosition="before" (keydown.enter)="$event.preventDefault()">専従</mat-checkbox>
              </div>
            </div>

          </div>

        </div>

        <!-- 保存ボタン -->
        <div class="button-area">
          <div class="signup-wrapper">
            <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving || form.invalid" class="yes-btn">
              保存
            </button>
            @if (isSaving) {
              <mat-spinner diameter="28" class="spinner2"></mat-spinner>
            }
          </div>
        </div>
    </div>
  </form>
  }